/**
 * exportPdf: triggers the browser's native print dialog (which any modern
 * browser can "print" to a PDF file) targeting only the setup sheet
 * content — not the whole app shell (nav, sidebars, etc.).
 *
 * Per the architecture decision in the implementation plan: simplest path
 * to crisp, accurately-scaled output without bloating the bundle with a
 * client-side PDF rendering library. The print CSS (index.css's @media
 * print rules, and Tailwind's print: variants used directly on
 * SetupSheetDocument) does the actual hiding of non-printable UI.
 *
 * This works by rendering SetupSheetDocument into a dedicated route
 * (/weddings/:weddingId/setup-sheet) rather than trying to print an
 * in-place modal — print stylesheets are far more reliable when the
 * printed content IS the page, not a fragment hidden inside other UI.
 */

export function triggerPrint() {
  window.print();
}
